var portfolioDelete = {
	title: "Suppression du portefeuille virtuel",
	nameInputLabel: "Nom du Portefeuille",
	alertHeading: "Etes-vous sûr de vouloir supprimer le portefeuille virtuel ?",
	alertBody: "Si oui, alors cliquez sur ok. Veuillez noter que les portefeuilles supprimés ne peuvent pas être restaurés.",
	confirmBtn: "Ok",
	cancelBtn: "Annuler"
};
var fr = {
	portfolioDelete: portfolioDelete
};

export { fr as default, portfolioDelete };
